import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';

const override = {
  baseUrl: 'https://pioneer-sec-service.uat.onyxcentersource.com',
  hostname: 'pioneer-sec.uat.onyxcentersource.com'
};

export const environment = defaultsDeep(override, environmentDefaults);



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/environments/environment.sec.ts